module.exports = __webpack_public_path__ + "img/facebook-logo.b70bffa9.svg";